import './ImageUploader.scss';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Icon from 'atoms/icon';

import PlaceholderImage from './PlaceholderImage';

export default function ImageUploader({
  saveImage,
  placeholder = 'camera',
  variant = 'default',
  size = 'medium',
  showEditIcon,
  showChangeImageText,
  avatar,
  className,
  cameraVariant,
  fileName = 'file',
  textPosition = 'bottom',
}) {
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);

  const getDefaultIconSize = () => {
    if (size === 'small') return 64;
    if (size === 'small-medium') return 36;
    if (size === 'medium') return 57;
    if (size === 'big') return 200;
    return 64;
  };

  const getPencilIconStyle = () => {
    if (size === 'small-medium') return { width: 14, height: 14 };
    return { width: 18, height: 18 };
  };

  useEffect(() => {
    if (!image) return;
    const newImage = URL.createObjectURL(image);
    setImageURL(newImage);

    const data = new FormData();
    data.append(fileName, image);

    saveImage(data);
  }, [image]);

  const onImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  return (
    <>
      <label
        htmlFor="file-upload"
        className={classNames(
          'image-uploader',
          `image-uploader--${variant}`,
          `image-uploader--${size}`,
          className
        )}
      >
        {!imageURL && !avatar && (
          <PlaceholderImage
            cameraVariant={cameraVariant}
            placeholder={placeholder}
            defaultIconSize={getDefaultIconSize()}
          />
        )}
        {showEditIcon && <Icon name="pencil" style={getPencilIconStyle()} />}
        {showChangeImageText && (imageURL || avatar) && (
          <p
            className={classNames(
              'c-primary-orange pos-absolute change-text',
              `change-text--${textPosition}`
            )}
          >
            Change photo
          </p>
        )}
      </label>
      <input
        id="file-upload"
        type="file"
        accept="image/*"
        onChange={onImageChange}
      />
      {(imageURL || avatar) && (
        <div
          className={classNames(
            'image-uploaded',
            `image-uploaded--${variant}`,
            `image-uploaded--${size}`
          )}
          style={{ background: `url(${imageURL || avatar})` }}
        />
      )}
    </>
  );
}

ImageUploader.propTypes = {
  avatar: PropTypes.string,
  className: PropTypes.string,
  fileName: PropTypes.string,
  placeholder: PropTypes.string,
  saveImage: PropTypes.func,
  showEditIcon: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'profile']),
  size: PropTypes.oneOf(['small', 'medium', 'big']),
  textPosition: PropTypes.oneOf(['bottom', 'right']),
};
